import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import JobsTable from './tables/JobsTable';
import { useSelector } from 'react-redux'
import endpoints, { getBackendUrl } from '../../endpoints';
import axios from 'axios';
import withAlert from '../../hoc/withAlerts'
import Loading from '../pages/parts/Loading'
import Stack from '@mui/material/Stack';

function Jobs(props) {

  const [rssList, setRssList] = useState([])
  const [rssId, setRssId] = useState('') // selected RSS id
  const [jobsList, setJobsList] = useState([])
  const [loading, setLoading] = useState(false)

  const token = useSelector((state) => state.auth.token)

  useEffect(() => {
    getRssList();
  }, []);

  const getRssList = async () => {
    let uri = getBackendUrl(endpoints.feeds, token)

    try {
      let res = await axios.get(uri)
      setRssList(res.data.items)
    } catch (e) {
      setRssList([])
      showAlertError('Unknown Error - get RSS list')
    }
  }

  const getJobsList = async () => {
    let uri = getBackendUrl(endpoints.jobs, token)
    let id = rssId
    uri = uri.replace('{id}', id)

    if (!rssId) {
      return showAlertError('Select RSS first')
    }

    try {
      setJobsList([])
      setLoading(true)

      let res = await axios.get(uri)
      setJobsList(res.data.items)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      setRssList([])
      showAlertError('Unknown Error - get Jobs list')
    }
  }

  const handleChangeSelectedRss = (e) => {
    setRssId(e.target.value)
  }

  const showAlertError = (message) => {
    props.showAlert(message, 'error')
  }

  const showAlertSuccess = (message) => {
    props.showAlert(message, 'success')
  }

  return (
    <Paper sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '20px' }}>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
      >
        <Toolbar>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Typography variant="h4" gutterBottom sx={{ paddingTop: 2 }}>
                Jobs
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {
        rssList.length !== 0 ?

          <Stack spacing={2} direction="row" sx={{ padding: 2 }}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Select RSS</InputLabel>
              <Select
                fullWidth
                labelId="demo-simple-select-label"
                label="Select RSS"
                value={rssId}
                onChange={handleChangeSelectedRss}
              >
                {
                  rssList.map((row, key) => (
                    <MenuItem key={key} value={row.id}>{row.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>

            {
              rssId === ''
                ? <Button variant="outlined" disabled>Exec</Button>
                : <Button variant="outlined" onClick={getJobsList}>Exec</Button>
            }

          </Stack>

          :

          <Stack direction="row" justifyContent="center">
            <Typography variant="h5" sx={{ padding: 2 }}>
              No RSS loaded...
            </Typography>
          </Stack>
      }

      {loading ? <Loading /> : null}

      <JobsTable items={jobsList} />

    </Paper>
  );
}

export default withAlert(Jobs)
